import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
export default function Error(props) {
  const { title } = props;
  return (
    <Alert severity="error">
      <AlertTitle>
        <strong>{title}</strong>
      </AlertTitle>
    </Alert>
  );
}
